export default [
  {
    path: "acciones-movimientos/destacamiento",
    name: "destacamiento_personal",
    component: () =>
      import( /* webpackChunkName: "destacamiento_personal" */ "@/views/acciones-movimientos/destacamiento/views/DestacamentoView.vue" ),
  },
  {
    path: "acciones-movimientos/destacamiento/solicitud/:tipo",
    name: "destacamento",
    component: () =>
      import( /* webpackChunkName: "destacamiento" */ "@/views/acciones-movimientos/destacamiento/views/DestacamentoSolicitud.vue" ),
  },
  {
    path: "acciones-movimientos/destacamiento/solicitud",
    name: "destacamento-plaza",
    component: () =>
      import( /* webpackChunkName: "destacamiento" */ "@/views/acciones-movimientos/destacamiento/views/DestacamentoSolicitud.vue" ),
  },
  {
    path: "acciones-movimientos/destacamiento/visualizar-solicitud/:id",
    name: "destacamiento_solicitud",
    component: () =>
      import( /* webpackChunkName: "destacamiento_crear" */ "@/views/acciones-movimientos/destacamiento/views/VisualizarDestacamento.vue" ),
  },
  {
    path: "acciones-movimientos/destacamiento/visualizar-solicitud-destino/:id",
    name: "destacamiento_solicitud_destino",
    component: () =>
      import( /* webpackChunkName: "destacamiento_crear" */ "@/views/acciones-movimientos/destacamiento/views/VisualizarDestacamentoDestino.vue" ),
  },
  {
    path: "acciones-movimientos/destacamiento/editar-solicitud/:id",
    name: "editar_solicitud_destacamiento",
    component: () =>
      import( /* webpackChunkName: "destacamiento_crear" */ "@/views/acciones-movimientos/destacamiento/views/EditarDestacamentoSolicitud.vue" ),
  },
  {
    path: "acciones-movimientos/destacamiento/peticion/:id",
    name: "destacamiento_peticion",
    component: () =>
      import( /* webpackChunkName: "destacamiento_crear" */ "@/views/acciones-movimientos/destacamiento/views/destacamientoSolicitud.vue" ),
  }
]